<template>
  <div class="dashboard container-fluid py-3 vh-100 vw-100">
    <!-- Header -->
    <div class="row">
      <!-- Header for CAM department -->
      <template v-if="isCurrentDepartment(departments.CAM) && testWorkQueuePhase.data === null">
        <div class="w-100">
          <div class="d-flex flex-column align-items-center px-2 h-100 position-relative">
            <!-- Logo -->
            <Brand :width="180" :withChat="testWorkQueuePhase.data !== null" />
            <!-- Redirect -->
            <div class="position-absolute top-0 start-0 p-2" @click="$router.go(-1)">
              <button class="btn rounded-btn-custom shadow bg-violet text-white">
                <div class="d-flex align-items-center">
                  <img src="@/assets/icons/arrow-left.svg" width="30" alt="arrow-left">
                  <strong class="text-uppercase">Indietro</strong>
                </div>
              </button>
            </div>
          </div>
        </div>
      </template>

      <!-- Normal header -->
      <template v-if="testWorkQueuePhase.data !== null">
        <div class="col-sm-12 col-md-12 col-lg-3 col-xl-3 col-xxl-2">
          <div class="d-flex flex-column justify-content-between align-items-start px-2 h-100">
            <!-- Logo -->
            <Brand :width="180" :withChat="testWorkQueuePhase.data !== null" />
            <!-- Redirect -->
            <div class="d-flex align-items-center" @click="$router.go(-1)"
              v-if="dashboardReadonly && showWareHouse === false">
              <button class="btn rounded-btn-custom shadow bg-violet text-white">
                <div class="d-flex align-items-center">
                  <img src="@/assets/icons/arrow-left.svg" width="30" alt="arrow-left">
                  <strong class="text-uppercase">Indietro</strong>
                </div>
              </button>
            </div>
            <!-- Manager -->
            <template v-if="hasRole('manager')">
              <MainButton class="my-2" :showBell="dataManagerCount > 0" :showChevronRight="true" />
            </template>
            <!-- Warehouse -->
            <div class="d-flex align-items-center position-relative" @click="showWareHouse = true"
              v-if="showWareHouse === false">
              <button class="btn rounded-btn-custom shadow bg-violet text-white">
                <div class="d-flex align-items-center">
                  <strong class="text-uppercase">magazzino</strong>
                  <img src="@/assets/icons/shopping-cart.svg" width="30" alt="shopping-cart">
                </div>
              </button>
            </div>
            <!-- Comeback -->
            <div class="d-flex align-items-center" @click="showWareHouse = false" v-else>
              <button class="btn rounded-btn-custom shadow bg-violet text-white">
                <div class="d-flex align-items-center">
                  <img src="@/assets/icons/arrow-left.svg" width="30" alt="arrow-left">
                  <strong class="text-uppercase">Indietro</strong>
                </div>
              </button>
            </div>
          </div>
        </div>
      </template>

      <template v-if="!isCurrentDepartment(departments.CAM) && testWorkQueuePhase.data !== null">
        <div class="col-sm-12 col-md-12 col-lg-9 col-xl-9 col-xxl-10">
          <!-- Prescription details -->
          <div class="d-flex card shadow rounded-custom justify-content-center p-2 h-100 w-100">
            <div class="d-flex p-2">
              <!-- Note -->
              <div class="d-flex p-2 flex-column" style="width: 60%;">
                <strong class="mb-3">
                  {{ isRefactor ? 'Rifacimento' : 'Prescrizione' }}
                  n.{{ prescription.number_text }}
                  <img class="me-2 cp" @click="copyHelper(prescription.number_text)" src="@/assets/icons/copy.svg"
                    width="20" alt="copy">
                  -
                  Creata il {{ moment(prescription.created_at).format("DD/MM/YYYY") }}
                  <template v-if="showNotesIcon">
                    <NotesIcon id="notesIcon" color="#725D82" class="ms-2" @click="() => showAllNotesModal = true" />
                  </template>
                </strong>
                <small class="text-uppercase fw-bold">
                  {{ testWorkQueuePhase.data.test_work_queue.prescription_test.name }}
                </small>
                <em class="mb-3">
                  {{
                  testWorkQueuePhase.data.test_work_queue.prescription_test.prescription?.prescription_rows[0]?.listRow?.name
                  || testWorkQueuePhase.data.test_work_queue.prescription_test.prescription?.prescription_rows[0]?.name
                  }}
                </em>
                <p class="mb-3">
                  {{ testWorkQueuePhase.data.test_work_queue.prescription_test.notes ?? "Nessuna nota presente" }}
                  <small class="text-muted fst-italic"
                    v-if="testWorkQueuePhase.data.test_work_queue.prescription_test.notes !== null">
                    -
                    {{ testWorkQueuePhase.data.test_work_queue.prescription_test.prescription.doctor.first_name }}
                    {{ testWorkQueuePhase.data.test_work_queue.prescription_test.prescription.doctor.last_name }}
                  </small>
                </p>
              </div>
              <!-- Vertical line -->
              <div class="vertical-line m-2"></div>
              <!-- Icons -->
              <div class="d-flex p-2 justify-content-evenly align-items-center" style="width: 60%;">
                <div class="d-flex flex-column text-center align-items-center">
                  <!-- Customer history -->
                  <template v-if="previousAssets.length > 0 && isCurrentDepartment(departments.PROGETTAZIONE)">
                    <div id="customer">
                      <div id="icon-box" @click="historyShowModal = true">
                        <img src="@/assets/icons/box.svg" height="40" alt="box">
                      </div>
                      <div id="blob">
                        <img src="@/assets/icons/blob.svg" height="170" alt="blob">
                      </div>
                      <div id="history-customer">
                        <img src="@/assets/icons/paziente.svg" width="35" height="35" alt="customer">
                        <div class="d-flex pt-2">
                          <small>
                            {{ prescription.customer.first_name }}
                            {{ prescription.customer.last_name }}
                          </small>
                        </div>
                      </div>
                    </div>
                  </template>
                  <template v-else>
                    <img src="@/assets/icons/paziente.svg" width="35" height="35" alt="customer">
                    <div class="d-flex pt-2">
                      <small>
                        {{ prescription.customer.first_name }}
                        {{ prescription.customer.last_name }}
                      </small>
                    </div>
                  </template>
                </div>
                <div class="d-flex flex-column text-center align-items-center">
                  <img src="@/assets/icons/poltrona_dentista.svg" width="35" height="35" alt="dentistchair">
                  <div class="d-flex pt-2">
                    <small>
                      {{testWorkQueuePhase.data.test_work_queue.prescription_test.prescription.clinic.name }}
                      <a class="link-dark"
                        :href="'tel:' + testWorkQueuePhase.data.test_work_queue.prescription_test.prescription.clinic.phone">
                        {{ testWorkQueuePhase.data.test_work_queue.prescription_test.prescription.clinic.phone }}
                      </a>
                    </small>
                  </div>
                </div>
                <div class="d-flex flex-column text-center align-items-center">
                  <img src="@/assets/icons/dottore.svg" width="35" height="35" alt="doctor">
                  <div class="d-flex flex-column pt-2">
                    <small>
                      {{testWorkQueuePhase.data.test_work_queue.prescription_test.prescription.doctor.first_name }}
                      {{testWorkQueuePhase.data.test_work_queue.prescription_test.prescription.doctor.last_name }}
                    </small>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
      <Confirm
        v-if="showPartialCompletionModal && isCurrentDepartment(departments.PROGETTAZIONE)"
        :modal_id="'modalConfirmPartialCompletion'"
        :title="'Conferma conclusione lavorazione'"
        :subtitle="'Non hai caricato tutti i progetti. Sei sicuro/a di voler procedere?'"
        :confirm_label="'Si'"
        :decline_label="'No'"
        @hidden="hidePartialCompletionModal"
        @confirm="completeInternalPhase"
        @decline="hidePartialCompletionModal" />
    </div>

    <!-- Dashboard -->
    <template v-if="showWareHouse === false && testWorkQueuePhase.data !== null">
      <div class="row h-75">
        <div class="current-work h-100 col-sm-12 col-md-12 col-lg-4 col-xl-4 col-xxl-3">
          <!-- Info current work -->
          <div class="card shadow rounded-custom overflow-auto h-100">

            <div class="card-header rounded-only-top bg-dark-violet text-center text-white text-uppercase m-0"
              :class="{'refactor': isRefactor}">
              <!-- Dynamic title by departments -->
              <template v-if="isCurrentDepartment(departments.PROGETTAZIONE)">progettazione</template>
              <template v-else>{{ testWorkQueuePhase.data.internal_phase.name }}</template>
            </div>

            <div class="card-body rounded-custom overflow-auto">
              <!-- Internal note LAB -->
              <div class="fw-bold">Note interne LAB</div>
              <template v-if="testWorkQueuePhase.data.parent_test_work_queue_phases.length > 0">
                <div class="mb-3"></div>
              </template>
              <template v-else>
                <p class="mb-3">Nessuna nota interna presente</p>
              </template>

              <!-- Internal note history -->
              <div class="mb-3">
                <small class="mb-3">
                  <a href="#" class="text-violet text-decoration-underline" @click="showHistoryInternalNotes = true">
                    Vedi tutte le note interne
                  </a>
                </small>
              </div>

              <hr />

              <!-- Works details -->
              <div class="fw-bold mb-2">Dettagli lavorazione</div>
              <div class="d-flex">
                <div>
                  <ul style="padding-left: 1.2rem;">
                    <li class="pb-1 fw-bold"><small>Materiale:
                        {{testWorkQueuePhase.data.test_work_queue.prescription_test.prescription.material_model?.name }}</small>
                    </li>
                    <li class="pb-1 fw-bold"><small>Tipo impianto:
                        {{testWorkQueuePhase.data.test_work_queue.prescription_test.prescription.plant_type }}</small>
                    </li>
                  </ul>
                </div>
                <div>
                  <ul style="padding-left: 3rem;">
                    <li class="pb-1 fw-bold"><small>Bruxista: {{ prescription.customer.bruxism ? "SI" : "NO" }}</small>
                    </li>
                    <li class="pb-1 fw-bold"><small>Colore: {{
                        testWorkQueuePhase.data.test_work_queue.prescription_test.prescription?.color?.code }}</small>
                    </li>
                  </ul>
                </div>
              </div>

              <hr />
              <Elements
                :is-able-to-project="isCurrentDepartment(departments.PROGETTAZIONE)"
                :elements="testWorkQueuePhase.data.test_work_queue.prescription_test.prescription?.prescription_rows"
                :models="models"
                :prescription-material="testWorkQueuePhase.data.test_work_queue.prescription_test.prescription.material_model"
                :prescription-color-id="testWorkQueuePhase.data.test_work_queue.prescription_test.prescription.color.id"
                :prescription-test-name="testWorkQueuePhase.data.test_work_queue.prescription_test.name"
                :test-material="testWorkQueuePhase.data?.test?.materials"
                :atLeastOneFileUploaded="atLeastOneFileUploaded"
                @update:atLeastOneFileUploaded="val => atLeastOneFileUploaded = val"
                @allFilesIsUploaded="readAllFilesIsUploaded"
                @all-models-is-uploaded="readAllModelsIsUploaded"
                @clear-models-selected="clearModelSelected"
                @sync-models="syncModelsData"
                @remove-assets-models="removeAssetsModel"
                @force-models-upload="forceModelsHandle"
                @remove-model="removeElement($event)"
                @add-model="addModel"
              />

              <hr>

              <template v-if="prescription.characterizations.length">
                <!-- Characterization -->
                <ul style="padding-left: 1.2rem;">
                  <li class="pb-3"><strong>Caratterizzazione:</strong></li>
                </ul>
                <div>
                  <Slider :teeth_characterization="prescription.characterizations" />
                </div>
              </template>
              <template v-else>
                <div class="mt-3">
                  Nessuna caratterizzazione presente.
                </div>
              </template>

              <hr>

              <div v-if="isDepartmentAllowed(departments.PROGETTAZIONE, departments.SCANSIONE, departments.FINITURA, departments.MOBILE)"
                class="d-flex justify-content-center">
                <button class="btn btn-violet text-uppercase me-2" @click="showDownloadModal = true">
                  <img class="me-2" src="@/assets/icons/download.svg" alt="download">
                  Download progetti
                </button>
                <button class="btn btn-violet text-uppercase" @click="showNonAssociatedModal = true">
                  <img class="me-2" src="@/assets/icons/link-slash.svg" alt="non-associated">
                  Non associati
                </button>
              </div>
              <div
                v-if="isPrescriptionScanNameCopied"
                class="prescription-scan-footer d-flex justify-content-center mt-2 p-3 w-100">
                <p class="w-100">{{ prescriptionScanName }}</p>
                <img
                  class="mb-4 ms-1 cursor-pointer"
                  src="@/assets/icons/copy.svg"
                  width="20"
                  alt="resume"
                  @click="copyPrescriptionScanName">
              </div>

              <Modal
                v-if="isDepartmentAllowed(departments.PROGETTAZIONE, departments.SCANSIONE, departments.FINITURA, departments.MOBILE) && showDownloadModal"
                :size="'lg'" :modal_id="'downloadProjectsModal'" :title="'Download Progetti'" :decline_label="'Chiudi'"
                :lightLayout="true" @hidden="showDownloadModal = false">
                <CADProjects :current-test-id="prescription.current_test_id" :customer-id="prescription.customer.id" />
              </Modal>

              <Modal
                 v-if="isDepartmentAllowed(departments.PROGETTAZIONE, departments.SCANSIONE, departments.FINITURA, departments.MOBILE) && showNonAssociatedModal"
                :size="'lg'" :modal_id="'nonAssociatedProjectsModal'" :title="'Progetti Non Associati'"
                :decline_label="'Chiudi'" :lightLayout="true" @hidden="showNonAssociatedModal = false">
                 <NonAssociatedProjects
                  :prescription-test-id="prescription.current_test_id"
                  :is-manager="false"
                  :items-per-page="10"
                  :show-brand="false"
                />
              </Modal>
            </div>


            <!-- Actions -->
            <div
              class="card-footer bg-dark-violet rounded-only-bottom d-flex position-absolute bottom-0 w-100 overflow-auto"
              :class="{disabled: dashboardReadonly, 'refactor': isRefactor}">
              <div class="d-flex p-0 gap-3">

                <!-- Situ -->
                <template v-if="showSITU && Object.keys(testWorkQueuePhaseChild).length > 0">
                  <div class="d-flex align-items-center">
                    <Situ :testWorkQueuePhaseId="testWorkQueuePhase.data.id"
                      :testWorkQueuePhaseChildId="testWorkQueuePhaseChild.id" />
                  </div>
                </template>

                <!-- External -->
                <template
                  v-if="isCurrentDepartment(departments.PROGETTAZIONE) || isCurrentDepartment(departments.MOBILE)">
                  <div class="d-flex align-items-center flex-column">
                    <button class="btn btn-outline-violet rounded-btn-custom bg-white rounded-circle p-2"
                      @click="requestExternal()">
                      <img src="@/assets/icons/van.svg" width="25" alt="van" />
                    </button>
                    <small class="text-white">{{ $t('External') }}</small>
                  </div>
                </template>

                <!-- Remember notes -->
                <div class="d-flex align-items-center flex-column">
                  <button class="btn btn-outline-violet rounded-btn-custom bg-white rounded-circle p-2"
                    style="padding: 10px;" @click="rememberNote()">
                    <img src="@/assets/icons/note.svg" width="25" alt="note">
                  </button>
                  <small class="text-white">{{ $t('Notes') }}</small>
                </div>

                <template v-if="canSuspend">
                  <!-- Suspend -->
                  <div class="d-flex align-items-center flex-column">
                    <button class="btn btn-outline-violet rounded-btn-custom bg-white rounded-circle p-2"
                      @click="requestSpecialSuspend()">
                      <img src="@/assets/icons/pause.svg" width="25" alt="pause">
                    </button>
                    <small class="text-white">{{ $t('Suspend') }}</small>
                  </div>
                </template>

                <!-- Info -->
                <div class="d-flex align-items-center flex-column">
                  <button class="btn btn-outline-violet rounded-btn-custom bg-white rounded-circle p-0"
                    @click="managerRequest('info')">
                    <img src="@/assets/icons/special/question.svg" width="41" alt="question" />
                  </button>
                  <small class="text-white">{{ $t('Assistance') }}</small>
                </div>

                <!-- Help -->
                <div class="d-flex align-items-center flex-column">
                  <button class="btn btn-outline-violet rounded-btn-custom bg-white rounded-circle p-0"
                    @click="managerRequest('warning')">
                    <img src="@/assets/icons/special/exclamation-circle.svg" width="41" alt="help" />
                  </button>
                  <small class="text-white">{{ $t('Criticality') }}</small>
                </div>

                <div
                  v-if="isCurrentDepartment(departments.SCANSIONE) || isCurrentDepartment(departments.PROGETTAZIONE)">
                  <div class="d-flex align-items-center flex-column" v-if="isPrescriptionScanNameCopied && !isCopying">
                    <button class="btn btn-outline-violet rounded-btn-custom bg-white rounded-circle p-2" @click="toFinish()">
                      <div class="d-flex align-items-center">
                        <div style="width: 25px; height: 25px">
                          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor"
                            class="bi bi-check-lg" viewBox="0 0 16 16">
                            <path
                              d="M13.485 1.431a1.473 1.473 0 0 1 2.104 2.062l-7.84 9.801a1.473 1.473 0 0 1-2.12.04L.431 8.138a1.473 1.473 0 0 1 2.084-2.083l4.111 4.112 6.82-8.69a.486.486 0 0 1 .04-.045z" />
                          </svg>
                        </div>
                      </div>
                    </button>
                    <small class="text-white">{{ $t('End') }}</small>
                  </div>

                  <div v-if="!isPrescriptionScanNameCopied && !isCopying" class="d-flex align-items-center flex-column">
                    <button class="btn btn-outline-violet rounded-btn-custom bg-white rounded-circle p-2"
                      @click="copyPrescriptionScanName">
                      <img src="@/assets/icons/copy-purple.svg" width="25" alt="copy" />
                    </button>
                    <small class="text-white">Copia</small>
                  </div>

                  <Spinner v-if="isCopying" class="mb-4" />
                </div>

                <div class="d-flex align-items-center"
                  v-if="!isCurrentDepartment(departments.SCANSIONE) && !isCurrentDepartment(departments.PROGETTAZIONE)">
                  <button class="btn btn-outline-violet rounded-btn-custom bg-white" @click="toFinish()">
                    <div class="d-flex align-items-center">
                      <div style="width: 25px; height: 25px">
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor"
                          class="bi bi-check-lg" viewBox="0 0 16 16">
                          <path
                            d="M13.485 1.431a1.473 1.473 0 0 1 2.104 2.062l-7.84 9.801a1.473 1.473 0 0 1-2.12.04L.431 8.138a1.473 1.473 0 0 1 2.084-2.083l4.111 4.112 6.82-8.69a.486.486 0 0 1 .04-.045z" />
                        </svg>
                      </div>
                      <strong>Termina</strong>
                    </div>
                  </button>
                </div>

              </div>
            </div>

          </div>

        </div>

        <div class="history h-100 col-sm-12 col-md-12 col-lg-8 col-xl-8 col-xxl-6">
          <!-- History -->
          <div :class="{disabled: dashboardReadonly}" class="d-flex card rounded-custom h-100 overflow-hidden">
            <div class="card-header rounded-only-top bg-dark-violet text-white text-uppercase d-flex justify-content-between align-items-center"
              :class="{'refactor': isRefactor}">
              <span>storico</span>
              <div class="d-flex align-items-center gap-3">
                <button
                  type="button"
                  class="btn btn-sm btn-outline-light d-flex align-items-center gap-2 btn-no-hover"
                  @click="globalNoteModal.show = true"
                  :disabled="!testWorkQueuePhase?.data?.test_work_queue?.prescription_test?.prescription?.chat_channel?.id"
                >
                  <img src="@/assets/icons/global-notes.svg" alt="global-notes" width="20" style="filter: brightness(0) invert(1);" />
                  <span>{{ globalNoteModal.title }}</span>
                </button>
                <TagSearchAction
                  :tag-search-items="tagSearchItems"
                />
              </div>
            </div>
            <div class="card-body h-100 p-0" style="overflow: auto;">
              <Wrapper
                :chat-channel-id="testWorkQueuePhase?.data?.test_work_queue?.prescription_test?.prescription?.chat_channel?.id"
                v-if="prescriptionTests?.length" :prescription-tests="prescriptionTests" readonly />
            </div>
          </div>
        </div>
        <div class="chat-projects h-100 col-sm-12 col-md-12 col-lg-4 col-xl-4 col-xxl-3">
          <div class="d-flex rounded-custom h-100">
            <div class="d-flex flex-column rounded-only-bottom w-100 h-100 position-relative">
              <ul :class="{'refactor': isRefactor}" class="nav nav-pills" id="pills-tab" role="tablist">
                <li class="nav-item" role="presentation">
                  <button class="nav-link text-uppercase rounded-only-top active" id="chat-tab" data-bs-toggle="pill"
                    data-bs-target="#chat" type="button" role="tab" aria-controls="chat" aria-selected="true">
                    <span class="me-1">chat</span>
                  </button>
                </li>
                <li class="nav-item" role="presentation" v-if="isCurrentDepartment(departments.FINITURA)">
                  <button class="nav-link text-uppercase rounded-only-top d-flex align-items-center" id="projects-tab"
                    data-bs-toggle="pill" data-bs-target="#projects" type="button" role="tab" aria-controls="projects"
                    aria-selected="false">
                    <span class="me-1">progetti</span>
                  </button>
                </li>
                <div class="close" @click="restoreWidth()">
                  <img src="@/assets/icons/x-circle-fill-violet.svg" width="35" alt="x-circle-fill-violet-add.svg">
                </div>
              </ul>
              <div class="tab-content bg-white h-100 rounded-only-bottom rounded-only-top-right" id="pills-tabContent">
                <div class="chat h-100 tab-pane fade show active" id="chat" role="tabpanel" aria-labelledby="chat-tab">
                  <template v-if="testWorkQueuePhase.data.test_work_queue.prescription_test.prescription !== null">
                    <Conversation
                      :prescription="testWorkQueuePhase.data.test_work_queue.prescription_test.prescription" />
                  </template>
                  <template v-else>
                    <Spinner />
                  </template>
                </div>
                <div class="projects tab-pane fade h-100 overflow-auto" id="projects" role="tabpanel"
                  aria-labelledby="project-tab">
                  <template v-if="isCurrentDepartment(departments.FINITURA) && apiParams">
                    <ProjectsAndScene :api-params="apiParams" />
                  </template>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- HALF CIRCLE -->
      <template v-if="showTabIcon">
        <HalfCircle @action="openChat()" />
      </template>
    </template>
    <!-- Warehouse -->
    <template v-if="showWareHouse">
      <div class="row h-75">
        <div class="products h-100 col-sm-12 col-md-12 col-lg-7 col-xl-7 col-xxl-7 p-2">
          <div class="card shadow rounded-custom h-100">
            <div class="card-header rounded-only-top bg-dark-violet p-3 text-center" :class="{'refactor': isRefactor}">
              <h3 class="text-white text-uppercase m-0">prodotti</h3>
            </div>
            <div class="d-flex flex-column card-body rounded-custom p-0 overflow-hidden">
              <GlobalSearch class="p-3" :label="'Ricerca prodotti'" :placeholder="'Ricerca categoria, prodotto...'"
                @toSearch="readValueToSearch" />
              <Products :search="toSearch" @add="addToOrders" />
            </div>
          </div>
        </div>
        <div class="orders h-100 col-sm-12 col-md-12 col-lg-5 col-xl-5 col-xxl-5 p-2">
          <div class="card shadow rounded-custom h-100">
            <div class="card-header rounded-only-top bg-dark-violet p-3 text-center border-0"
              :class="{'refactor': isRefactor}">
              <h3 class="text-white text-uppercase m-0">ordine</h3>
            </div>
            <div class="d-flex flex-column card-body p-0 overflow-hidden">
              <Order :data="order" :warehouse-request-update="pusherRequests['warehouse_request_change-state']" />
            </div>
          </div>
        </div>
      </div>
    </template>
  </div>

  <!-- Components -->
  <Modal v-if="historyShowModal" :size="'xl'" :modal_id="'history'" :title="'Lavori precedenti'"
    :subtitle="'Esiste una corrispondenza con lavori precedentemente svolti'" :decline_label="null" :lightLayout="true"
    @hidden="historyCloseModal">
    <LastAssets :data="previousAssets" :first-name="prescription.customer.first_name"
      :last-name="prescription.customer.last_name" />
  </Modal>

  <InternalNotes v-if="showHistoryInternalNotes"
    :title="testWorkQueuePhase.data.test_work_queue.prescription_test.name + ' / Note interne LAB'"
    :test_work_queue_id="testWorkQueuePhase.data.test_work_queue.id" @historyNotes="modalNotesHide">
  </InternalNotes>

  <Completed
    v-if="completedModal.show"
    :title="completedModal.title"
    :subtitle="completedModal.subtitle"
    :all-files-uploaded="allFilesUploaded"
    :test_work_queue_phase_id="$props.test_work_queue_phases_id"
    :test_work_queue_id="testWorkQueuePhase.data.test_work_queue.id"
    :is_last="testWorkQueuePhase.data.children_test_work_queue_phases.length <= 0"
    :children_test_work_queue_phase="testWorkQueuePhase.data.children_test_work_queue_phases"
    @hidden="modalCompletedHide" />

  <!-- Clipboard modal -->
  <Empty v-if="showClipboard" :size="'md'" :modal_id="'specialSuspendModal'" @hidden="closeClipboardModal">
    <div class="mb-3 p-3">
      <label for="clipboard" class="form-label">
        Appunta le tue note qui!</label>
      <textarea class="form-control" id="clipboard" rows="10" v-model="clipboard">
    </textarea>
    </div>
  </Empty>

  <!-- Special suspend modal -->
  <Empty
    v-if="showSpecialSuspend"
    :size="'md'"
    :modal_id="'specialSuspendModal'"
    @hidden="closeSpecialSuspendModal">
    <SpecialActions
      :title="specialActionContent.title"
      :subtitle="specialActionContent.subtitle"
      :modelNameSelect="specialActionContent.specialMotivationIdSelected"
      :placeholderNameSelect="'Seleziona la motivazione'"
      :optionsSelect="specialActionContent.specialMotivations"
      :notesMode="notesRequired ? 'required' : 'optional'"
      @selected="setMotivationIdSelected"
      @clear="clearSpecialMotivationSelected"
      @store="storeSpecialMotivation"
      @close="closeSpecialMotivationModal">
      <template v-if="showRejectedSelect">
        <MultiselectCustom
          id="rejectedSelect"
          class="multiselect-violet mb-3"
          v-model="rejectedReasonIdSelected"
          :searchable="true"
          :placeholder="'Seleziona uno'"
          :options="rejectedReasons" />
      </template>
    </SpecialActions>
  </Empty>

  <!-- Vendors modal -->
  <Empty
    v-if="showVendorsModal"
    size="md"
    modal_id="vendorsModal"
    @hidden="closeExternalVendorsModal">
    <SpecialActions
      :title="$t('Select vendor')"
      :modelNameSelect="specialActionContent.vendorIdSelected"
      placeholderNameSelect="seleziona..."
      :optionsSelect="vendors"
      @selected="setVendorIdSelected"
      @clear="clearVendorSelected"
      @store="storeVendor" @close="closeVendorsModal" />
  </Empty>

  <!-- All notes modal -->
  <Modal v-if="showAllNotesModal" class="overflow-auto" size="lg" modal_id="historyNotes" title="Tutte le note"
    decline_label="chiudi" :lightLayout="false" :disabled="!readAll"
    :options="readAll ? {} : {backdrop: 'static', keyboard: false}" @hidden="closeAllNotesModal">
    <Notes :prescription-test-id="prescription.current_test_id" :notes="prescriptionTestNotes" :readConfirmation="true"
      @readAll="setReadAll" />
  </Modal>

  <!-- Global notes modal -->
  <Empty
    v-if="globalNoteModal.show"
    :modal_id="'globalNoteModal'"
    :size="globalNoteModal.size"
    @hidden="globalNoteModal.show = false"
  >
    <div class="d-flex flex-column h-100">
      <div class="ms-4 py-2 d-flex bg-white border-bottom sticky-top" style="z-index: 1020;">
        <Brand :width="150" />
        <div class="mb-3 m-auto text-center">
          <div class="fs-5 fw-semibold">{{ $t('Work Detail') }} - {{ $t('Prescription') }}</div>
        </div>
      </div>
      <div class="flex-grow-1 overflow-auto">
        <GlobalPrescriptionNotes
          v-if="testWorkQueuePhase?.data?.test_work_queue?.prescription_test?.prescription?.chat_channel?.id && prescriptionTests?.length"
          :chat-channel-id="testWorkQueuePhase.data.test_work_queue.prescription_test.prescription.chat_channel.id"
          :prescription-id="prescriptionTests[0].prescription_id"
          @close="closeGlobalNoteModal"
        />
      </div>
      <div class="bg-white border-top p-3 d-flex justify-content-center" style="z-index: 1020;">
        <button type="button" class="btn btn-violet text-uppercase px-4" @click="closeGlobalNoteModal">
          {{ $t('Close') }}
        </button>
      </div>
    </div>
  </Empty>

  <StuckWorkWarningProvider />
</template>

<script>
import {
  ref,
  onMounted,
  reactive,
  computed,
  getCurrentInstance,
  onUnmounted,
  watch,
  inject,
  toRaw
} from "vue";
import { onBeforeRouteUpdate, useRouter } from "vue-router";
import { useStore } from "vuex";
import _head from "lodash/head";
import _filter from "lodash/filter";
import _cloneDeep from "lodash/cloneDeep";
import _some from "lodash/some";
import _get from "lodash/get";
import _camelCase from "lodash/camelCase";
import moment from "moment";

import Brand from '@/components/Brand';
import Spinner from "@/components/general/Spinner";
import Completed from "@/components/dashboard/Completed";
import InternalNotes from "@/components/InternalNotes";
import LastAssets from "@/components/Project/LastAssets";
import Slider from "@/components/general/Slider";
import Elements from "@/components/Project/Elements";
import Modal from "@/components/Modal/Standard";
import GlobalSearch from "@/components/GlobalSearch";
import Products from "@/components/warehouse/technician/Products";
import Order from "@/components/warehouse/technician/Order";
import Situ from "@/components/Situ";
import Empty from "@/components/Modal/Empty";
import SpecialActions from "@/components/SpecialActions";
import MainButton from "@/components/Manager/MainButton";
import Confirm from "@/components/Modal/Confirm";
import HalfCircle from "@/components/general/HalfCircle";
import Conversation from "@/components/chat/Conversation";
import NotesIcon from "@/components/Icons/Notes";
import Notes from "@/components/Notes";
import ProjectsAndScene from "@/components/dashboard/ProjectsAndScene.vue";
import Wrapper from "@/components/History/Wrapper.vue";
import GlobalPrescriptionNotes from "@/components/History/GlobalPrescriptionNotes.vue";
import MultiselectCustom from "@vueform/multiselect";
import CADProjects from "@/components/CADProjects.vue";
import NonAssociatedProjects from "@/components/NonAssociatedProjects.vue";
import StuckWorkWarningProvider from "@/components/StuckWorkWarningProvider.vue";
import TagSearchAction from "@/components/devices/TagSearchAction.vue";

import { update as updateTestWorkQueuePhase } from '@/use/repositories/testWorkQueuePhase/update';
import { update as updateState } from '@/use/repositories/testWorkQueue/update';
import { store as storeFeedback } from "@/use/repositories/feedbacks/store";
import { fetchById as fetchTestWorkQueuePhaseById } from '@/use/repositories/testWorkQueuePhase/fetchById';
import { fetchById as fetchCharacterization } from "@/use/repositories/prescriptions/fetchById.js";
import { fetchById as fetchPrescriptionById } from '@/use/repositories/prescriptions/fetchById';
import { hideModal as closeModal } from '@/use/modal/hide';
import { departmentException } from '@/use/departmentException';
import { changeState } from '@/use/repositories/users/changeState';
import { fetchByRole as fetchVendors } from "@/use/repositories/users/fetchByRole";
import { index as fetchAllMaterials } from "@/use/repositories/materials/index";
import { externalPhases } from "@/use/repositories/testWorkQueuePhase/externalPhases";
import { fetchByType } from '@/use/repositories/feedbacks/fetchByType';
import { fetchByDepartmentSlug } from "@/use/repositories/testWorkQueuePhase/fetchByDepartmentSlug";
import { fetchNotes } from "@/use/repositories/prescriptions/fetchNotes";
import { useI18n } from "vue-i18n";
import { warning } from "@/use/toast/warning";
import { success } from "@/use/toast/success";
import { fetchRejectedReasons } from "@/use/repositories/prescriptionTestRejected/fetchRejectedReasons";
import { storeAsRejected } from "@/use/repositories/prescriptionTestRejected/storeAsRejected";
import { groupedByBridgesAndTooth } from '@/use/repositories/prescriptionRows/groupedByBridgesAndTooth';
import { isRefactorPrescription } from "@/use/utilities/isRefactorPrescription";
import { isCurrentDepartment } from "@/use/utilities/isCurrentDepartment";
import { hasRole } from "@/use/utilities/users/hasRole";
import { copyHelper } from "@/use/utilities/copyHelper";
import { error } from "@/use/toast/error";
import { getPrescriptionScanName, copyPrescriptionScanName } from '@/utils/prescriptionScanName';

export default {
  name: 'Dashboard',
  components: {
    Brand,
    Conversation,
    HalfCircle,
    Order,
    Completed,
    InternalNotes,
    Wrapper,
    GlobalPrescriptionNotes,
    Slider,
    Elements,
    LastAssets,
    Modal,
    GlobalSearch,
    Products,
    Situ,
    Empty,
    SpecialActions,
    MainButton,
    Confirm,
    NotesIcon,
    Notes,
    ProjectsAndScene,
    Spinner,
    MultiselectCustom,
    CADProjects,
    NonAssociatedProjects,
    StuckWorkWarningProvider,
    TagSearchAction,
  },
  props: [
    'test_work_queue_phases_id',
  ],
  setup(props) {
    const { departments, assetsType, states, userStates, modelConfigs } = inject("constants");
    const testWorkQueuePhase = reactive({data: null});
    const technicianStatus = ref(null);
    const userData = reactive({});
    const store = useStore();
    const router = useRouter();
    const prescription = reactive({
      id: '',
      number_text: '',
      created_at: null,
      characterizations: [],
      customer: {},
      current_test_id: undefined,
    });
    const completedModal = reactive({
      show: false,
      title: null,
      subtitle: null,
    });
    const showHistoryInternalNotes = ref(false);
    const historyShowModal = ref(false);
    const showDownloadModal = ref(false);
    const showNonAssociatedModal = ref(false);
    const atLeastOneFileUploaded = ref(false);
    const allFilesUploaded = ref(false);
    const showPartialCompletionModal = ref(false);

    let dashboardReadonly = departmentException(store.state.userData);
    const showWareHouse = ref(false);
    const toSearch = ref("");
    const order = ref(null);
    // Pusher request.
    const pusherRequests = ref({
      'warehouse_request_change-state': null,
    });
    // Pusher instance.
    const internalInstance = getCurrentInstance();
    const pusher = internalInstance.appContext.config.globalProperties.$pusher;
    const showSpecialSuspend = ref(false);
    const showRejectPrescriptionTestModal = ref(false);
    const showVendorsModal = ref(false);
    const specialActionContent = reactive({
      type: null,
      title: null,
      subtitle: null,
      specialMotivationIdSelected: null,
      specialMotivations: [],
      vendorIdSelected: null
    });

    const setSpecialActionTitle = () => {
      switch (specialActionContent.type) {
        case 'resumable':
          specialActionContent.title = i18n.t('Select resumable suspension reason');
          specialActionContent.subtitle = i18n.t('Resumable suspension description');
          break;
        case 'info':
          specialActionContent.title = i18n.t('Select assistance suspension reason');
          specialActionContent.subtitle = i18n.t('Assistance suspension description');
          break;
        case 'warning':
          specialActionContent.title = i18n.t('Select critical suspension reason');
          specialActionContent.subtitle = i18n.t('Critical suspension description');
          break;
      }
    }

    const rejectedReasons = ref([]);
    const rejectedReasonIdSelected = ref([]);
    const showRejectedSelect = ref(false);
    const vendors = ref([]);
    const isPrescriptionScanNameCopied = ref(false);
    const isCopying = ref(false);

    const canSuspend = [
      departments.SCANSIONE,
      departments.FINITURA,
      departments.MOBILE,
      departments.PREPARAZIONE,
      departments.PROGETTAZIONE,
    ].includes(store.state.mainRole.team.name);

    const notesRequired = ref(true);
    const showClipboard = ref(false);
    const clipboard = ref("");
    const dataManagerCount = ref(0);
    const showTabIcon = ref(false);
    const showAllNotesModal = ref(false);
    const prescriptionTestNotes = ref([]);
    const readAll = ref(false);
    const showNotesIcon = ref(false);
    const modelMaterials = ref([]);
    const i18n = useI18n();
    const globalNoteModal = reactive({
      show: true,
      size: 'fullscreen',
      title: i18n.t('Global notes'),
    });
    const tagSearchItems = computed(() => {
      if (!isCurrentDepartment(departments.PROGETTAZIONE)) return [];

      const currentPrescriptionTest = testWorkQueuePhase.data?.test_work_queue?.prescription_test;
      const loadedPrescriptionTestWithTag = prescriptionTests.value.find(
        (test) => test.id === currentPrescriptionTest?.id
      );
      const tagDevice = currentPrescriptionTest?.device ?? loadedPrescriptionTestWithTag?.device;
      const prescriptionForTagSearch =
        currentPrescriptionTest?.prescription ?? loadedPrescriptionTestWithTag?.prescription;
      const testWorkQueueForTagSearch =
        testWorkQueuePhase.data?.test_work_queue ?? loadedPrescriptionTestWithTag?.test_work_queue;

      if (!currentPrescriptionTest || !tagDevice) return [];

      return [
        {
          id: testWorkQueuePhase.data?.id ?? null,
          prescription_test_id: currentPrescriptionTest.id,
          name: prescriptionForTagSearch?.number_text ?? prescription.number_text,
          first_name: prescriptionForTagSearch?.customer?.first_name ?? prescription.customer?.first_name,
          last_name: prescriptionForTagSearch?.customer?.last_name ?? prescription.customer?.last_name,
          delivery_date: moment(testWorkQueueForTagSearch?.delivery_date).format("DD/MM/YYYY HH:mm"),
          internal_phase: testWorkQueuePhase.data?.internal_phase,
          device_id: tagDevice.id,
          device_name: tagDevice.name,
        },
      ];
    });
    // TODO: estrarre in componentistica dedicata -> solo progettazione
    const modelInitialState = {
      must_upload: false,
      prescription: {},
      arch: {
        elements: [],
      },
      gum: {
        elements: [],
      },
      stump: {
        elements: [],
      },
      customPin: {
        elements: [],
      },
      baseArch: {
        elements: [],
      },
      gig: {
        elements: [],
      },
      bracket: {
        elements: [],
      },
      bar: {
        elements: [],
      },
    };

    const models = reactive(_cloneDeep(modelInitialState));

    const allModelsIsUploaded = ref(false);

    const isRefactor = computed(() => {
      return isRefactorPrescription(prescription?.number_text);
    })

    const apiParams = ref(null);

    // Department slug.
    const showSITU = computed(() => {
      return store.state.mainRole.team.name === departments.PREPARAZIONE;
    });

    const testWorkQueuePhaseChild = computed(() => {
      if (testWorkQueuePhase.data.children_test_work_queue_phases.length > 0) {
        return _head(testWorkQueuePhase.data.children_test_work_queue_phases);
      }

      return {};
    });

    const prescriptionTests = ref([]);

    const resetModels = () => {
      const clonedInitialState = _cloneDeep(modelInitialState);
      Object.assign(models, clonedInitialState);
    }

    const forceModelsHandle = (value) => {
      if (value) {
        storeDefaultModels();
      } else {
        resetModels();
      }
    }

    const storeDefaultModels = () => {
      models.must_upload = true;
      // Add prescription info.
      models.prescription = {
        id: testWorkQueuePhase.data.test_work_queue.prescription_test.prescription.id,
        colorScale: testWorkQueuePhase.data.test_work_queue.prescription_test.prescription.color,
      };
    }

    // Check if the prescription rows are the same.
    const previousAssets = computed(() => {
      // Get previous prescription rows.
      let previousPrescriptionRows = testWorkQueuePhase?.data?.test_work_queue?.prescription_test?.prescription?.customer?.assets;

      let innerPrescriptionRows = [];
      if (previousPrescriptionRows && previousPrescriptionRows.length > 0) {
        previousPrescriptionRows.forEach((element) => {
          element?.prescription_rows?.forEach((innerElement) => {
            // Push data to the array.
            innerPrescriptionRows.push({
              asset_id: element.id,
              test_work_queue_phase_id: element.test_work_queue_phase_id,
              created_at: element.created_at,
              number_text: element.prescription?.number_text,
              material: element.prescription?.material,
              bridge: innerElement.bridge,
              zone_number: innerElement.zone_number,
              application: innerElement.application,
            });
          });
        });
      }

      return innerPrescriptionRows;
    });

    watch(() => clipboard.value, (value) => {
      // Set clipboard on vuex.
      store.dispatch("setClipboardDashboardTechnician", value);
    });
    watch(() => store.state.clipboardDashboardTechnician, (valueOnStore) => {
      clipboard.value = valueOnStore;
    });

    // Pusher.
    const subscribe = (channelName) => {
      console.log(`subscribing from "${channelName}"...`, { $pusher: pusher });
      const channel = pusher.subscribe(channelName);
      channel.bind("pusher:subscription_succeeded", () => console.log("subscription succeeded"));
      const callback = (eventName, data) => {
        switch (eventName) {
          case "warehouse_request_change-state":
            pusherRequests.value[eventName] = data;
            break;
          case "manager_change_phase_state":
            if ([
              states.SENT_TO_EXTERNAL,
              states.ON_HOLD,
            ].includes(data.state.slug)) {
              dataManagerCount.value++;
            }
            break;
        }
        //console.log(`bind global channel: The event ${eventName} was triggered with data ${JSON.stringify(data)}`);
      };
      // bind to all events on the channel
      channel.bind_global(callback);
    };

    const existsDataManager = (data) => {
      dataManagerCount.value = _filter(data, function(testWorkQueuePhase) {
        if ([
          states.ON_HOLD,
          states.SENT_TO_EXTERNAL,
        ].includes(testWorkQueuePhase.state.slug)) {
          return testWorkQueuePhase;
        }
      }).length;
    }

    // Hide the partial completion confirmation modal, i.e. the modal
    // that asks the user if he wants to complete the test work queue phase.
    const hidePartialCompletionModal = (value) => {
      showPartialCompletionModal.value = value;
    };

    onBeforeRouteUpdate(async (to) => {
      if (router.currentRoute.value.path !== to.href) {
        // Reload.
        window.location.replace(to.href);
      }
    });

    const defineModelMaterials = (allMaterials) => {
      const usedMaterials = new Set(Object.values(modelConfigs).map(cfg => cfg.material));

      modelMaterials.value = allMaterials.filter(material => usedMaterials.has(material.slug));
    }

    onMounted(async () => {
      if (hasRole('manager')) {
        const statesSlug = [states.ON_HOLD, states.IN_THE_WORKS];
        if (isCurrentDepartment(departments.MOBILE)) {
          statesSlug.push(states.SENT_TO_EXTERNAL);
        }
        // Fetch manager counter.
        fetchByDepartmentSlug(
          store.state.mainRole.team.name,
          statesSlug,
          'by_department_and_states'
        ).then((response) => {
          existsDataManager(response.departmentTestWorkQueuePhases.test_work_queue_phases);
        });

      }

      // Set clipboard value if exists in vuex.
      if (store.state.mainRole.team.name !== null) {
        clipboard.value = store.state.clipboardDashboardTechnician;
      }

      // Enabled warehouse boxes.
      if (isCurrentDepartment(departments.CAM)) {
        // Activate warehouse tab.
        showWareHouse.value = true;
        return;
      }

      try {
        const { materials } = await fetchAllMaterials();
        defineModelMaterials(materials);
      } catch (error) {
        console.error(error);
      }

      await getUserWorkQueuePhases();

      fetchPrescriptionById(testWorkQueuePhase.data.test_work_queue?.prescription_test?.prescription.id, 'with_prescription_tests:with_trashed', false)
        .then((response) => {
          prescriptionTests.value = response.prescription.prescription_tests.map(test => ({
            ...test,
            is_current_test: testWorkQueuePhase.data?.test_work_queue?.prescription_test?.prescription?.current_test_id === test.id
          }));
      });

      // Subscribe to channel.
      subscribe(`presence-user.${store.state.user.id}`);
    });

    const closeAllNotesModal = () => { showAllNotesModal.value = false }

    // Unsubscribe to channel.
    const unsubscribeChannel = (channelName) => {
      console.log(`unsubscribing from "${channelName}"...`, {
      $pusher: pusher,
      });
      pusher.unsubscribe(channelName);
    };

    onUnmounted(() => {
      unsubscribeChannel(`presence-user.${store.state.user.id}`);
    });

    const getAction = () => {
      if (isCurrentDepartment(departments.PROGETTAZIONE)) {
        return "with_assets";
      }

      return "with_all_relationships";
    }

    const getAssetsBySlug = (assets, typeSlug) => {
      if (! assets?.length) return [];

      return assets.filter((asset) => asset?.type?.slug === typeSlug);
    }

    const getModelBucketKey = (key) => {
      return (key === 'upperArch' || key === 'lowerArch') ? 'arch' : key;
    };

    const prefillAllAssets = (modelsAssets) => {
      for (const key in modelConfigs) {
        const config = modelConfigs[key];
        const assets = getAssetsBySlug(modelsAssets, config.assetType);

        if (! assets.length) continue;

        const elements = assets.map((asset, index) => ({
          name: config.name,
          slug: `${config.assetType}${index}`,
          application: config.application,
          selected: false,
          assets: [asset],
          icon: config.icon,
          type: config.assetType,
        }));

        models[getModelBucketKey(key)].elements.push(...elements);
      }
    };

    // Get test work queue phases assigned.
    const getUserWorkQueuePhases = async () => {
      await fetchTestWorkQueuePhaseById(props.test_work_queue_phases_id, getAction()).then(async (response) => {
        testWorkQueuePhase.data = response.testWorkQueuePhase;

        prescription.id = _get(testWorkQueuePhase, 'data.test_work_queue.prescription_test.prescription.id', '');
        prescription.current_test_id = _get(testWorkQueuePhase, 'data.test_work_queue.prescription_test.prescription.current_test_id', '');
        prescription.number_text = _get(testWorkQueuePhase, 'data.test_work_queue.prescription_test.prescription.number_text', '');
        prescription.created_at = _get(testWorkQueuePhase, 'data.test_work_queue.prescription_test.prescription.creation_date', '');
        prescription.customer = _get(testWorkQueuePhase, 'data.test_work_queue.prescription_test.prescription.customer', {});

        await fetchCharacterization(testWorkQueuePhase?.data?.test_work_queue?.prescription_test?.prescription?.id, 'with_teeth_characterizations').then((response) => {
          prescription.characterizations =  response.prescription.teeth_characterizations;
        });

        apiParams.value = {
          prescription_test_id: prescription.current_test_id,
          action: 'by_prescription_test',
        };
        // Get notes.
        getNotes();
        // Fetch all notes by prescription id.
        fetchNotes(prescription.id).then((response) => {
          if (_some(response.notes.prescription_tests, 'laboratory_notes.length')) {
            showNotesIcon.value = true;
          }
        });
        // TODO Retrieve the information only if the parent is of type ISO or if you have intraoral scan.
        // TODO if (testWorkQueuePhase.data.test_work_queue.is_model_required) {
        storeDefaultModels();
        const modelsAssets = testWorkQueuePhase.data?.assets;
        prefillAllAssets(modelsAssets);
      });
    };

    const getNotes = () => {
      // Fetch all notes by prescription id.
      fetchNotes(prescription.id).then((response) => {
        // Reverse prescription test order.
        prescriptionTestNotes.value = response.notes.prescription_tests.reverse();
        // Show modal if exists notes.
        prescriptionTestNotes.value.forEach((prescriptionTest) => {
          if (prescriptionTest.laboratory_notes.length && (prescriptionTest.id === prescription.current_test_id)) {

            // Check if already read all notes.
            let counter = 0;
            let allNotesLength = prescriptionTest.laboratory_notes.length;

            prescriptionTest.laboratory_notes.forEach((note) => {
              const usersUnique = [...new Set(note.users.map(user => user.id))];
              if (usersUnique.includes(store.state.user.id)) {
                return counter++;
              }
            });

            readAll.value = (counter === allNotesLength);

            if (!readAll.value) {
              // Open modal notes.
              showAllNotesModal.value = true;
            }
          }
        });
      });
    }

    watch(() => readAll.value, (value) => {
      if (!value) {
        // Open modal notes.
        showAllNotesModal.value = true;
      }
    });

    /**
     * Mark the test work queue phase as completed.
     */
    const completeInternalPhase = () => {
      completedModal.show = true;
    };

    /**
     * Work queue phase in completion.
     * Let's check uploaded assets if CAD.
     */
    const toFinish = async () => {
      if (allFilesUploaded.value || !isCurrentDepartment(departments.PROGETTAZIONE)) {
        completeInternalPhase();
      } else if (atLeastOneFileUploaded.value) {
        const assetSummary = await getAssetSummary();
        const summaryText = getFormattedAssetSummary(Object.entries(assetSummary));
        completedModal.title = 'Attention you are concluding the work without uploading all the necessary files.';
        completedModal.subtitle = summaryText;
        completeInternalPhase();
      } else {
        warning(i18n.t('Before continuing, complete the upload of at least one file in the UPLOAD FILE section'));
      }
    }

    const requestExternal = () => {
      if (isCurrentDepartment(departments.PROGETTAZIONE) && !allFilesUploaded.value) {
        return warning(i18n.t('Before continuing, complete the upload of all files in the UPLOAD FILE section'));
      }

      if (! isCurrentDepartment(departments.MOBILE)) {
        // Get vendors.
        fetchVendors('vendor', 'with_test_work_queue_phases').then((response) => {
          vendors.value = response.users.map((item) => {
            return {
              value: item.id,
              label: `${item.first_name} ${item.last_name}`,
            };
          });

          showVendorsModal.value = true;
        });
      } else {
        // Update test work queue.
        updateTestWorkQueuePhase({
            source_ids: [parseInt(props.test_work_queue_phases_id)],
            state: states.SENT_TO_EXTERNAL,
            action: "update",
          }).then(async () => {
          // Show message.
          setTimeout(() => {
            success(i18n.t('Request sent to manager successfully!'));
          }, 3000);

          // Change user state.
          changeState(userStates.AVAILABLE).then(async () => {
            // Redirect to check in.
            return router.push({ name: "Checkin" });
          });
        });
      }
    }

    const rejectPrescriptionTest = async () => {
      fetchRejectedReasons().then((response) => {
        rejectedReasons.value = response.rejectedReasons;
      });
    }

    watch(() => specialActionContent.specialMotivationIdSelected, async (value) => {
      showRejectedSelect.value = false;
      const foundReason = specialActionContent.specialMotivations.find((reason) => reason.value == value);

      if (foundReason && foundReason.slug === 'rejected') {
        await rejectPrescriptionTest().then(() => {
          showRejectedSelect.value = true;
        });
      }
    });

    const managerRequest = (type) => {
      fetchByType(type, {
        action: 'with_feedbacks',
        internal_phase_id:  testWorkQueuePhase.data.internal_phase.id,
        state_slug: states.ON_HOLD,
      }).then((response) => {
        specialActionContent.type = type;
        setSpecialActionTitle();
        specialActionContent.specialMotivations = response.feedbacks;
        // Show special suspend modal.
        showSpecialSuspend.value = true;
        notesRequired.value = true;
      });
    }

    const requestSpecialSuspend = () => {
      const type = 'resumable';
      fetchByType(type, {
        action: 'with_feedbacks',
        internal_phase_id:  testWorkQueuePhase.data.internal_phase.id,
        state_slug: states.ON_HOLD,
      }).then((response) => {
        if (response.feedbacks.length) {
          specialActionContent.type = type;
          setSpecialActionTitle();
          specialActionContent.specialMotivations = response.feedbacks;
          // Show special suspend modal.
          showSpecialSuspend.value = true;
          // Disabled notes on component.
          notesRequired.value = false;
        } else {
          // Show message
          warning(i18n.t('No reasons for suspension found!'));
        }
      });
    }

    const storeRejected = () => {
      const reasonSlug = rejectedReasons.value.find((reason) => reason.value == rejectedReasonIdSelected.value).slug;
      storeAsRejected(testWorkQueuePhase.data.test_work_queue.prescription_test.id.toString(), 'pending', reasonSlug);
    }

    const storeSpecialMotivation = (note) => {
      storeFeedback({
        test_work_queue_phase_id: parseInt(props.test_work_queue_phases_id),
        state: states.ON_HOLD,
        is_iso: Boolean(false),
        note: note,
        feedback_id: specialActionContent.specialMotivationIdSelected,
        action: "without_media",
      }).then(async () => {
      // Change user state.
      changeState(userStates.AVAILABLE).then(async () => {
        if (showRejectedSelect.value) {
          updateState({
            id: testWorkQueuePhase.data.test_work_queue.id,
            state_slug:"non-complient",
            action: "update_state"
          });
          storeRejected();
        }
        // Destroy modal instance.
        closeSpecialMotivationModal();
        // Redirect to check in.
        return router.push({ name: "Checkin" });
      });
    });
    }

    const storeVendor = () => {
      externalPhases(
        parseInt(props.test_work_queue_phases_id),
        isCurrentDepartment(departments.MOBILE),
        specialActionContent.vendorIdSelected,
      ).then(async () => {
        updateTestWorkQueuePhase({
            source_ids: [parseInt(props.test_work_queue_phases_id)],
            state: states.COMPLETED,
            action: "update",
          }).then(async () => {
          // Change user state.
          changeState(userStates.AVAILABLE).then(async () => {
            // Destroy modal instance.
            closeVendorsModal();
            // Redirect to check in.
            return router.push({ name: "Checkin" });
          });
        });
      });
    }

    const rememberNote = () => {
      showClipboard.value = true;
    }

    const restoreWidth = () => {
      let currentWork = document.getElementsByClassName('current-work');
      let history = document.getElementsByClassName('history');
      let chatBox = document.getElementsByClassName('chat-projects');

      _head(currentWork).classList.remove('col-xxl-3');
      _head(currentWork).classList.add('col-xxl-4');

      _head(history).classList.remove('col-xxl-6');
      _head(history).classList.add('col-xxl-7');

      _head(chatBox).classList.add('d-none');

      showTabIcon.value = true;
    }

    const openChat = () => {
      let currentWork = document.getElementsByClassName('current-work');
      let history = document.getElementsByClassName('history');
      let chatBox = document.getElementsByClassName('chat-projects');

      _head(currentWork).classList.remove('col-xxl-4');
      _head(currentWork).classList.add('col-xxl-3');

      _head(history).classList.remove('col-xxl-7');
      _head(history).classList.add('col-xxl-6');

      _head(chatBox).classList.remove('d-none');

      showTabIcon.value = false;
    }

    const closeSpecialMotivationModal = () => {
      closeModal('specialSuspendModal');
    }
    const closeVendorsModal = () => {
      closeModal('vendorsModal');
    }

    // Read emits.
    const modalCompletedHide = (value) => {
      completedModal.show = value;
      completedModal.title = null;
      completedModal.subtitle = null;
    };
    const modalNotesHide = (value) => {
      showHistoryInternalNotes.value = value
    };
    const historyCloseModal = (value) => {
      historyShowModal.value = value;
    }

    const setReadAll = (value) => {
      readAll.value = value;
    }

    const readAllFilesIsUploaded = (value) => {
      allFilesUploaded.value = value;
    }
    const readValueToSearch = (value) => {
      toSearch.value = value;
    }
    const addToOrders = (article) => {
      order.value = article;
    }
    const closeRejectPrescriptionTestModal = () => {
      showRejectPrescriptionTestModal.value = false;
      specialActionContent.specialMotivationIdSelected = null;
    }
    const closeSpecialSuspendModal = () => {
      showSpecialSuspend.value = false;
      specialActionContent.specialMotivationIdSelected = null;
    }
    const closeClipboardModal = () => {
      showClipboard.value = false;
    }
    const closeExternalVendorsModal = () => {
      showVendorsModal.value = false;
      specialActionContent.vendorIdSelected = null;
    }
    const clearSpecialMotivationSelected = () => {
      specialActionContent.vendorIdSelected = null;
    }
    const clearVendorSelected = () => {
      specialActionContent.specialMotivationIdSelected = null;
    }
    const setVendorIdSelected = (vendorId) => {
      specialActionContent.vendorIdSelected = vendorId;
    }
    const setMotivationIdSelected = (motivationId) => {
      specialActionContent.specialMotivationIdSelected = motivationId;
    }

    const clearModelSelected = () => {
      models.arch.elements.forEach((arch) => arch.selected = false);
      models.gum.elements.forEach((gum) => gum.selected = false);
      models.stump.elements.forEach((stump) => stump.selected = false);
      models.customPin.elements.forEach((pin) => pin.selected = false);
      models.baseArch.elements.forEach((baseArch) => baseArch.selected = false);
      models.gig.elements.forEach((gig) => gig.selected = false);
      models.bracket.elements.forEach((bracket) => bracket.selected = false);
      models.bar.elements.forEach((bar) => bar.selected = false);
    }

    const syncModelsData = ({ type, slug, asset }) => {
      let element
      if ([assetsType.LOWER_ARCH, assetsType.UPPER_ARCH].includes(type)) {
        element = models.arch.elements.find(el => el.slug === slug);
      } else {
        element = models[_camelCase(type)].elements.find(el => el.slug === slug);
      }
      (element.assets ??= []).push(asset);
    };

    const removeAssetsModel = (ids) => {
      Object.values(models).forEach(model => {
        if (Array.isArray(model.elements)) {
          model.elements.forEach(el => {
            if (el.assets.some(asset => ids.includes(asset.id))) {
              el.assets = [];
            }
          });
        }
      });
      // Remove assets from the original test work queue phase data.
      testWorkQueuePhase.data.assets = testWorkQueuePhase.data.assets.filter(asset => !ids.includes(asset.id));
    };

    const createElement = (modelKey, config) => {
      models[modelKey].elements.push({
        ...config,
        material: modelMaterials.value.find(material => material.slug === config.material),
        slug: `${config.assetType}${new Date().getTime()}`,
        selected: false,
        assets: [],
        type: config.assetType,
      });
    };

    const removeElement = (key) => {
      const bucketKey = getModelBucketKey(_camelCase(key));
      const index = models[bucketKey].elements.findIndex(
        el => el.assets.length === 0 && el.type === key
      );
      if (index !== -1) {
        models[bucketKey].elements.splice(index, 1);
        clearModelSelected();
      }
    };

    const addModel = (type) => {
      const camelType = _camelCase(type);
      const config = modelConfigs[camelType];
      if (!config) {
        console.warn(`Nessuna configurazione per il tipo: ${type}`);
        return;
      }
      createElement(getModelBucketKey(camelType), config);
    }

    const readAllModelsIsUploaded = (value) => {
      allModelsIsUploaded.value = value;
    }

    const prescriptionScanName = computed(() => {
      if (!prescription.id || !testWorkQueuePhase.data.test_work_queue.id) {
        return '';
      }
      return getPrescriptionScanName(prescription, testWorkQueuePhase.data.test_work_queue.id);
    });

    const copyPrescriptionScanNameHandler = async () => {
      isCopying.value = true;
      await copyPrescriptionScanName(prescriptionScanName.value, {
        i18n: i18n.t,
        success,
        error,
      });
      setTimeout(() => {
        isCopying.value = false;
        isPrescriptionScanNameCopied.value = true;
      }, 1000);
    };

    function getFormattedAssetSummary(entries) {
      if (entries.length === 0) return i18n.t('No files uploaded');
      const totalCount = entries.reduce((sum, [, count]) => sum + count, 0);
      const verb = totalCount === 1 ? i18n.t('Has been uploaded') : i18n.t('Have been uploaded');

      const parts = entries.map(([type, count]) => `${count} ${i18n.t('file for')} ${type}`);
      const listStr = parts.length > 1
        ? `${parts.slice(0, -1).join(', ')} ${i18n.t('e')} ${parts.at(-1)}`
        : parts[0];

      return `${verb} ${listStr}.`;
    }

    async function getAssetSummary() {
      const summary = {};
      const { bridges, tooth } = await new Promise(resolve => resolve(groupedByBridgesAndTooth(toRaw(testWorkQueuePhase.data.test_work_queue.prescription_test.prescription?.prescription_rows))));

      tooth?.forEach(item => {
        const type = item.name || "Unknown";
        const assetCount = item.assets?.length || 0;
        if (assetCount > 0) {
          summary[type] = (summary[type] || 0) + assetCount;
        }
      });

      bridges?.forEach(bridge => {
        bridge.tooth?.forEach(toothItem => {
          const type = toothItem.name || "Unknown (Bridge)";
          const assetCount = toothItem.assets?.length || 0;
          if (assetCount > 0) {
            summary[type] = (summary[type] || 0) + assetCount;
          }
        });
      });

      const modelSections = models || {};
      for (const sectionKey in modelSections) {
        const section = modelSections[sectionKey];
        const elements = section.elements || [];

        elements.forEach(el => {
          const type = el.name || sectionKey;
          const assetCount = el.assets?.length || 0;
          if (assetCount > 0) {
            summary[type] = (summary[type] || 0) + assetCount;
          }
        });
      }

      return summary;
    }

    const isDepartmentAllowed = (...allowedDepartments) => {
      return allowedDepartments.some(dept => isCurrentDepartment(dept));
    };

    const closeGlobalNoteModal = () => {
      closeModal('globalNoteModal');
    };

    return {
      showTabIcon,
      restoreWidth,
      testWorkQueuePhase,
      getUserWorkQueuePhases,
      technicianStatus,
      modalCompletedHide,
      modalNotesHide,
      showHistoryInternalNotes,
      userData,
      prescription,
      dashboardReadonly,
      previousAssets,
      historyCloseModal,
      historyShowModal,
      showDownloadModal,
      showNonAssociatedModal,
      readAllFilesIsUploaded,
      hidePartialCompletionModal,
      completeInternalPhase,
      showPartialCompletionModal,
      toFinish,
      showWareHouse,
      readValueToSearch,
      toSearch,
      addToOrders,
      order,
      pusherRequests,
      allFilesUploaded,
      showSITU,
      testWorkQueuePhaseChild,
      showSpecialSuspend,
      closeSpecialSuspendModal,
      specialActionContent,
      clearSpecialMotivationSelected,
      clearVendorSelected,
      storeSpecialMotivation,
      closeSpecialMotivationModal,
      closeVendorsModal,
      showVendorsModal,
      closeExternalVendorsModal,
      requestExternal,
      vendors,
      storeVendor,
      setVendorIdSelected,
      setMotivationIdSelected,
      managerRequest,
      requestSpecialSuspend,
      canSuspend,
      notesRequired,
      moment,
      rememberNote,
      showClipboard,
      clipboard,
      closeClipboardModal,
      hasRole,
      dataManagerCount,
      openChat,
      showAllNotesModal,
      closeAllNotesModal,
      prescriptionTestNotes,
      readAll,
      setReadAll,
      showNotesIcon,
      models,
      clearModelSelected,
      syncModelsData,
      removeAssetsModel,
      readAllModelsIsUploaded,
      allModelsIsUploaded,
      apiParams,
      forceModelsHandle,
      rejectPrescriptionTest,
      closeRejectPrescriptionTestModal,
      storeRejected,
      rejectedReasons,
      rejectedReasonIdSelected,
      showRejectedSelect,
      isRefactor,
      isCurrentDepartment,
      departments,
      prescriptionTests,
      copyHelper,
      prescriptionScanName,
      getPrescriptionScanName,
      copyPrescriptionScanName: copyPrescriptionScanNameHandler,
      isPrescriptionScanNameCopied,
      isCopying,
      assetsType,
      createElement,
      globalNoteModal,
      closeGlobalNoteModal,
      tagSearchItems,
      removeElement,
      addModel,
      completedModal,
      atLeastOneFileUploaded,
      isDepartmentAllowed,
    };
  },
};
</script>

<style scoped lang="scss">
  @import "@/scss/abstracts/_variables.scss";

  .nav-link, .nav-link:hover {
    color: $dark_violet;
  }
  .nav-pills .nav-link.active, .nav-pills .show > .nav-link {
    color: #fff;
    background-color: #7E6492;
  }
  .nav-pills.refactor .nav-link.active, .nav-pills .show > .nav-link {
    color: #fff;
    background-color: #301934;
  }
  .chat-projects {order: 3;}
  .history {order: 2;}
  .current-work {order: 1;}
  .products {order: 1;}
  .orders {order: 2;}
  h1 {
    font-size: 5.5rem;
  }
  #notesIcon:hover {
      cursor: pointer;
  }
  .vertical-line {
    width: 0.1%;
    background-color: gray;
  }
  .btn-outline-violet:hover {
    color: #A58ABA !important;
    background-color: #fff !important;
    border-color: #A58ABA !important;
  }
  .disabled {
    pointer-events: none;
    opacity: 0.3;
  }
  #history-customer {
    z-index: 999;
  }
  #customer {
    z-index: 1;
    position: relative;
  }
  #blob {
    position: absolute;
    z-index: -1;
    transform: rotate(368deg);
    top: -77%;
    left: -8%;
  }
  #icon-box {
    padding: 10px;
    background-color: #A58ABA;
    border-radius: 50%;
    position: absolute;
    top: -50%;
    left: -10%;
    box-shadow: 0 .5rem 1rem rgba(0,0,0,.15);
  }
  #icon-box:hover {
    transform: scale(1.1);
    transition: all .2s ease-in-out;
    cursor: pointer;
  }
  .close:hover {
    cursor: pointer;
  }
  .close {
    position: absolute;
    right: 5px;
    top: 0;
  }
  [class*="col-"] {
    margin-bottom: 15px;
  }
  .card-header.refactor,
  .card-footer.refactor {
    background-color: #301934 !important;
  }

  .btn-no-hover:hover {
    background-color: transparent !important;
    border-color: #ffffff !important;
    color: #ffffff !important;
  }

  @media screen and (max-width: 1400px) {
    .chat-projects {display: block !important;}
    .btn-close-chat, .half-circle {display: none;}
    .close { display: none !important; }
  }
  @media screen and (max-width: 991px) {
    .chat-projects {order: 1;}
    .history {order: 2;}
    .current-work {order: 3;}
    .products {order: 2;}
    .orders {order: 1;}
  }
</style>
